module.exports = __webpack_public_path__ + "app/components/api/docs.view.html";